import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const track = (event, meta = {}) => {
  // Fire-and-forget telemetry; must never block or throw in the UI.
  api.post("/track", { event, path: window.location.pathname, meta })
    .catch((e) => console.debug("track failed", event, e?.message));
};

export const fileUrl = (url) => (url?.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);
